<template>
    <UModal :model-value="open" @update:model-value="$emit('update:open', $event)">
        <UCard :ui="{ rounded: 'rounded-lg' }">
            <template #header>
                <div class="flex items-center justify-between">
                    <h3 class="text-base font-medium leading-6 text-gray-800">
                        Suspend {{ doctor ? [doctor.title, doctor.full_name].filter(Boolean).join(' ') : 'doctor' }}?
                    </h3>
                    <UButton color="gray" variant="ghost" icon="i-ph-x-bold" class="-my-1" @click="$emit('update:open', false)" />
                </div>
            </template>
            <div class="flex items-start gap-3">
                <div class="flex size-10 flex-shrink-0 items-center justify-center rounded-full bg-red-50">
                    <UIcon name="i-ph-prohibit-duotone" class="size-5 text-red-500" />
                </div>
                <p class="text-sm text-gray-600">
                    Suspending hides the doctor from the app and blocks new bookings. You can reinstate them to draft later.
                </p>
            </div>
            <template #footer>
                <div class="flex items-center justify-end space-x-2">
                    <UButton @click="$emit('update:open', false)" size="lg" color="white">
                        Cancel
                    </UButton>
                    <UButton @click="confirm()" size="lg" :loading="loading" color="red">
                        Suspend
                    </UButton>
                </div>
            </template>
        </UCard>
    </UModal>
</template>

<script setup lang="ts">
import { DoctorStatus, type DoctorProfile } from '~/types/telemedicine'

const emit = defineEmits<{
    'update:open': [boolean]
    'reload': [boolean]
}>()

const props = defineProps<{
    open: boolean
    doctor?: DoctorProfile
}>()

const { changeStatus } = useDoctorActions()
const loading = ref(false)

async function confirm() {
    if (!props.doctor) return
    loading.value = true
    const ok = await changeStatus(props.doctor, DoctorStatus.suspended)
    loading.value = false
    if (ok) {
        emit('update:open', false)
        emit('reload', true)
    }
}
</script>
